import styled from 'styled-components';
export const AppBar = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  box-shadow: none;
  margin: 0 18px 0 6px;
`;
export const Separator = styled.div`
  height: 36px;
  width: 1px;
  background: rgba(53, 59, 96, 0.2);
`;